import * as React from "react";
const SvgMegaphoneFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M20.659 2.06A1 1 0 0 1 22 3v16a1 1 0 0 1-1.341.94L10 16.064V5.936zM9 6H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h6zM4 17v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-3z" }));
export default SvgMegaphoneFill;
